import { useRouter } from 'next/router';
import { Dispatch, useCallback, useEffect } from 'react';
import { Sort } from '../types';
import useUpdateRouter from './updateRouter';

const useApplySort = (
  setSelectedSort: Dispatch<Sort>,
  setPage: Dispatch<number>,
  sortOptions: Sort[],
) => {
  const router = useRouter();
  const { query } = router;
  const { updateRouter } = useUpdateRouter();

  const applySort = useCallback(
    (option: Sort) => {
      setSelectedSort(option);
      setPage(1);
      router.query.sortBy = option.value;
      const regionSlug = router.asPath.split('/')[1];
      router.pathname = router.pathname.replace('[:region]', regionSlug);
      updateRouter(router);
    },
    [router],
  );

  useEffect(() => {
    if (router.isReady) {
      initializeSort(query);
    }
  }, [router.isReady]);


  const initializeSort = (query: any) => {
    const { sortBy } = query;
    if (sortBy) {
      const sort = sortOptions.find((o) => o.value === sortBy);
      applySort(sort || sortOptions[0]);
    }
  };

  return { applySort, initializeSort };
};

export default useApplySort;
